const slugify = (value = '') => value.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

export const DOCUMENT_SECTIONS = [
  {
    key: 'FSSAI_MANDATED_DOCUMENTS_LEVEL_1',
    label: 'FSSAI MANDATED DOCUMENTS - 1',
    titles: [
      'FSSAI REGISTRATION COPY',
      'FoSTaC CERTIFICATE - BASIC',
      'MEDICAL FITNESS CERTIFICATE FOR FOOD HANDLERS',
      'FOOD SAFETY DISPLAY BOARD',
    ],
  },
  {
    key: 'FSSAI_MANDATED_DOCUMENTS_LEVEL_2',
    label: 'FSSAI MANDATED DOCUMENTS - 2',
    titles: [
      'FSSAI LICENSE',
      'FoSTaC CERTIFICATE - BASIC',
      'FoSTaC CERTIFICATE - ADVANCED',
      'FOOD SAFETY DISPLAY BOARD',
      'MEDICAL FITNESS CERTIFICATE FOR FOOD HANDLERS',
      'WATER TESTING REPORT - NABL',
      'ANNUAL RETURNS - D1',
      'ANNUAL RETURNS - D2',
      'THIRD PARTY / HIGH RISK AUDIT REPORT',
      'RECALL PLAN',
      'FSMS (FOOD SAFETY MANAGEMENT SYSTEM) DECLARATION',
      'BATCH MANUFACTURING RECORD (BMR)',
      'PLANT LAYOUT / BLUEPRINT',
      'FORM IX',
      'LABEL PROOFS',
      'LIST OF MACHINERY / EQUIPMENTS WITH POWER CONSUMPTION',
      'FSSAI APPROVED SUPPLIER RECORD',
    ],
  },
  {
    key: 'FSSAI_RECOMMENDED_DOCUMENTS',
    label: 'FSSAI RECOMMENDED DOCUMENTS',
    titles: [
      'FOOD TESTING REPORT - NABL',
      'CALIBRATION CERTIFICATE - NABL',
      'PEST CONTROL AGENCY - WORK DONE REPORT',
      'PEST CONTROL AGENCY - FORM III',
      'OIL TESTING REPORT - NABL',
      'RUCO EMPANELMENT CERTIFICATE',
      'RUCO - OIL COLLECTION REPORT',
      'MIGRATION REPORT - PACKAGING MATERIAL',
      'INTERNAL AUDIT REPORT',
      'AIR QUALITY MONITORING REPORT',
      'NOISE LEVEL TESTING REPORT',
      'ENVIRONMENTAL TESTING REPORT',
      'SWAB TESTING REPORT',
      'HYGIENE RATING CERTIFICATE - QCI',
      'ORGANISATION CHART',
      'RAW MATERIAL VENDOR RECORD',
      'FOOD PACKAGING VENDOR RECORD',
      'CLEANING RECORD',
      'PREVENTIVE MAINTENANCE RECORD',
      'TEMPERATURE RECORD FOR FOOD',
      'TEMPERATURE RECORD FOR EQUIPMENTS',
      'THAWING RECORD',
      'WASTE MANAGEMENT RECORD',
      'STAFF HYGIENE RECORD',
      'STOCK REGISTER RECORD',
      'ICE CUBE TESTING REPORT',
      'CONSUMER COMPLAINT REDRESSAL MECHANISM RECORD',
      'MSDS SHEET FOR CLEANING AGENTS',
      'MSDS SHEET FOR PEST CONTROL AGENTS',
      'FORM E - CERTIFICATE OF GUARANTEE',
      'ZONING MAP (HIGH RISK, LOW RISK, RAW AREA, RTE AREA)',
      'CHEMICAL STORAGE RECORD',
      'TRAINING RECORD',
    ],
  },
  {
    key: 'GMP_RECOMMENDED_DOCUMENTS',
    label: 'GMP RECOMMENDED DOCUMENTS',
    titles: [
      'TNPCB NO OBJECTION CERTIFICATE',
      'SUPPLIER AUDIT / SUPPLIER QUALITY ASSURANCE PROGRAM',
      'SOP FOR RAW MATERIAL RECEIVING',
      'SOP FOR RAW MATERIAL STORAGE',
      'SOP FOR PERSONAL HYGIENE & GROOMING',
      'SOP FOR HANDWASHING',
      'SOP FOR WASHING FOODS',
      'SOP FOR CUTTING',
      'SOP FOR THAWING',
      'SOP FOR COOKING & HOT HOLDING',
      'SOP FOR REHEATING',
      'SOP FOR COOLING & COLD HOLDING',
      'SOP FOR DINING',
      'SOP FOR BUFFET SERVING',
      'SOP FOR FOOD TRANSPORT / DELIVERY',
      'SOP FOR CLEANING',
      'SOP FOR SANITISING',
      'SOP FOR DISINFECTING',
      'SOP FOR EQUIPMENT MAINTENANCE',
      'SOP FOR ALLERGEN CONTROL',
      'SOP FOR PEST MANAGEMENT',
      'SOP FOR WASTE MANAGEMENT',
      'SOP FOR VISITOR ENTRY & VISITOR HYGIENE',
    ],
  },
  {
    key: 'HACCP_DOCUMENTS',
    label: 'HACCP DOCUMENTS',
    titles: [
      'HAZARD ANALYSIS TABLE',
      'CCP DECISION TREE DOCUMENT',
      'CCP MONITORING SHEET',
      'VERIFICATION AND VALIDATION RECORDS',
      'HACCP PLAN REVIEW REPORTS',
      'DEVIATION AND CORRECTIVE ACTION REGISTER',
      'BREAKAGE LOG',
      'CORRECTIVE ACTION & PREVENTIVE ACTION',
      'ISO',
      'QUALITY POLICY',
      'OBJECTIVES & GOALS',
      'ORGANISATIONAL CHART',
      'FOOD SAFETY MANUAL',
      'DOCUMENT INFORMATION CONTROL',
      'INTERNAL AUDIT PROCEDURE',
      "SOP'S (INCLUDING FIRE SAFETY, LPG, WATER TANK)",
      'INSTRUCTIONS',
      'ROLES & RESPONSIBILITIES OF A FOOD SAFETY TEAM',
      'FOOD SAFETY TEAM APPOINTMENT LETTER',
      'EMERGENY PROCEDURE (FOOD POISONING)',
      'EVENT CATERING SPECIFIC SOP',
      'FOOD DISPATCH LOAD PLANNING SOP',
      'ON SITE BUFFET SETUP SOP',
      'ON SITE TEMPERATURE MAINTENANCE SOP',
      'ON SITE HANDWASH & HYGIENE STATION SOP',
      'HANDLING LEFT OVER FOOD SOP',
      'TRAINING MODULE FOR TEMPORARY EVENT WORKERS',
      'FOOD PHOTOGRAPHY FOR TRACEABILITY & EVIDENCE',
      'REAL TIME TEMPERATURE MONITORING SYSTEM DATA',
      'VEHICLE GPS + TEMPERATURE TRACKING',
      'MENU ALLERGEN CHART',
      'COLOR CODED CHOPPING BOARD SOP',
      'FOOD POISONING INCIDENT REPORT',
      'CONSUMER FEEDBACK RECORD',
    ],
  },
];

export const FLATTENED_DOCUMENT_TITLES = DOCUMENT_SECTIONS.flatMap((section) =>
  section.titles.map((title) => ({
    documentTitleId: `${slugify(section.key)}__${slugify(title)}`,
    title,
    sectionKey: section.key,
    sectionLabel: section.label,
  })),
);

export const DOCUMENT_TITLE_MAP = FLATTENED_DOCUMENT_TITLES.reduce((acc, item) => {
  acc[item.documentTitleId] = item;
  return acc;
}, {});

export const SECTION_MAP = DOCUMENT_SECTIONS.reduce((acc, section) => {
  acc[section.key] = section;
  return acc;
}, {});
